var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"app":"","color":"white","elevation":"2"}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.handleNavIconClick()}}}),_c('v-toolbar-title',[_vm._v("KPN Callback Manager")]),_c('v-spacer'),_c('LoginLogoutButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }